<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">

      <!-- Sidebar user panel (optional) -->
      <div class="user-panel">
        <div class="pull-left image">
          <i class="fas fa-user"></i>
        </div>
        <div class="pull-left info">
          <div>
            <p class="white username" v-html="displayName"></p>
          </div>
          <a href="javascript:;" id="status"  v-if="this.$store.state.online"> 
          		<i class="fa fa-circle text-success"></i> Online
          </a>
          <a href="javascript:;" id="status" v-if="!this.$store.state.online"> 
          		<i class="fa fa-circle text-danger"></i> Offline
          </a>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
      <div id="version-app">
        V{{ $store.state.version }}
      </div>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
/* eslint-disable */
import SidebarMenu from './SidebarMenu'
import { mapState } from 'vuex'
export default {
    name: 'Sidebar',
    components: { SidebarMenu },
    computed: {
      ...mapState([
        'user','generalAlert'
      ]),
      displayName () {
        return (this.user ? this.user.nombre + ' ' + this.user.apellido + '<br>' + this.user.email : null)
      }
    },    
    data: function () {
        return {
       	}
    },
    mounted: function() {
      window
        .jQuery('[data-toggle="hideseek"]')
        .off()
        .hideseek()
    }
}

</script>
<style scope="local">
.user-panel .image img {
  border-radius: 50%;
}
#searchForm {
  padding-left: 0em;
  padding-right: 0em;
}
#searchContainer {
  height: 100%;
  padding-bottom: 0em;
}
#search {
  width: 80%;
  float: right;
}

#search-btn {
  width: 20%;
}
.skin-red .main-header .logo {
    background-color: #222D32;
}
.skin-red .main-header .logo:hover{
    background-color: #222D32;
}
.fa-user{
    color: white;
    font-size: 26px;
    margin: 6px auto;
}
.user-panel>.info {
    left: 35px;
}
.user-panel>.info>a, .username {
    font-size: 14px;
}
.username {
    font-size: 12px;
}
.user-panel{
    height: 5em;
}
#version-app{
    position: absolute;
    bottom: 0;
    left: 0;
    color: #fff;
    display: block;
    text-align: center;
    width: 100%;  
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue